import { useEffect, useState } from "react";
import { QualityIcon } from "../../../../assets/svg/QualityIcon";
import { CloseIcon } from "../../../../assets/svg/CloseIcon";
import styles from "./QualityButton.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { setQuality } from "../../../../redux/reducers/ui/uiReducer";
import { getQuality } from "../../../../redux/reducers/ui/uiSelectors";
import { stateT } from "../../../../redux/reducers/types";
import { QualityType } from "../../../../utils/constants";

export const QualityButton = () => {
  const [isOpenPopup, setIsOpenPopup] = useState(false);
  const dispatch = useDispatch();
  const reduxQuality = useSelector((state: stateT) => getQuality(state));
  const [selectedQuality, setSelectedQuality] = useState<QualityType>(
    reduxQuality || "Full HD"
  );

  useEffect(() => {
    dispatch(setQuality(selectedQuality));
  }, []);

  useEffect(() => {
    if (reduxQuality && reduxQuality !== selectedQuality) {
      setSelectedQuality(reduxQuality);
    }
  }, [reduxQuality]);

  const handleTogglePopup = () => {
    setIsOpenPopup(!isOpenPopup);
  };

  const handleQualityChange = (quality: QualityType) => {
    setSelectedQuality(quality);
    dispatch(setQuality(quality));
  };

  return (
    <div className={styles.wrapper}>
      <button onClick={handleTogglePopup} data-tour="full-hd-button">
        <QualityIcon /> {selectedQuality}
      </button>
      {isOpenPopup ? (
        <div className={styles.popup}>
          <div className={styles.header}>
            Resolution
            <button onClick={() => setIsOpenPopup(false)}>
              <CloseIcon />
            </button>
          </div>
          <div className={styles.content}>
            <label
              className={styles.radioLabel}
              onChange={() => handleQualityChange("Full HD")}
            >
              <input
                type="radio"
                name="quality"
                value="full"
                checked={selectedQuality === "Full HD"}
              />
              <span>Full HD</span>
            </label>
            <label
              className={styles.radioLabel}
              onChange={() => handleQualityChange("2k")}
            >
              <input
                type="radio"
                name="quality"
                value="2k"
                checked={selectedQuality === "2k"}
              />
              <span>2k</span>
            </label>
            <label
              className={styles.radioLabel}
              onChange={() => handleQualityChange("4k")}
            >
              <input
                type="radio"
                name="quality"
                value="2k"
                checked={selectedQuality === "4k"}
              />
              <span>4k</span>
            </label>
          </div>
        </div>
      ) : null}
    </div>
  );
};
